import React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";

const Icon = (props) => {
  const theme = useTheme();
  const { size } = props;
  return (
    <Svg
      width={size ?? 10}
      height={size ?? 14}
      viewBox="0 0 10 14"
      fill="none"
      {...props}
    >
      <path
        d="M1.33333 0H8C8.35362 0 8.69276 0.140476 8.94281 0.390524C9.19286 0.640573 9.33334 0.979711 9.33334 1.33333V12C9.33334 12.3536 9.19286 12.6928 8.94281 12.9428C8.69276 13.1929 8.35362 13.3333 8 13.3333H1.33333C0.979712 13.3333 0.640573 13.1929 0.390524 12.9428C0.140476 12.6928 0 12.3536 0 12V1.33333C0 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979712 0 1.33333 0ZM1.33333 1.33333V4H8V1.33333H1.33333ZM1.33333 5.33333V6.66667H2.66667V5.33333H1.33333ZM4 5.33333V6.66667H5.33333V5.33333H4ZM6.66667 5.33333V6.66667H8V5.33333H6.66667ZM1.33333 8V9.33333H2.66667V8H1.33333ZM4 8V9.33333H5.33333V8H4ZM6.66667 8V9.33333H8V8H6.66667ZM1.33333 10.6667V12H2.66667V10.6667H1.33333ZM4 10.6667V12H5.33333V10.6667H4ZM6.66667 10.6667V12H8V10.6667H6.66667Z"
        fill={theme.colors.foregroundHighEmphasis}
      />
    </Svg>
  );
};

export default Icon;
